import { useAfterHydration } from 'hooks/helpers/useBrandCookie'
import { isSmartfitClient } from 'utils/cookieHelpers'

/** `isSmartfitClient()` for render, hydration-safe on the server-rendered pages (see useAfterHydration). */
export const useIsSmartfitClient = (): boolean => useAfterHydration(isSmartfitClient)
